module.exports = __webpack_public_path__ + "media/images/athletes/2023-52972a568cf51ad44b96c117f49d68fb.png";